import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-options-chain-link a')

export default function OptionsChainLink() {
  const currentTimeframePath = useChartTimeframePathWatch()
  if (!currentTimeframePath)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        Options Chain
      </a>
    )

  return (
    <a href={`${currentTimeframePath}&ty=oc`} className="tab-link">
      Options Chain
    </a>
  )
}
